import { Suspense, lazy } from "react";
import { Navigate, type RouteObject } from "react-router";

import { DASHBOARD_SETTINGS_LOADER } from "@application/loaders/dashboard_settings_loader";

import { DASHBOARD_SETTINGS_LINK } from "@application/navigation/dashboard_settings_link";

import { Loader } from "@styled/loader";

const DashboardSettings = lazy(() =>
  import("./settings").then((m) => ({ default: m.DashboardSettings })),
);
const SettingsAdmin = lazy(() =>
  import("./settings_admin").then((m) => ({ default: m.SettingsAdmin })),
);
const SettingsNotifications = lazy(() =>
  import("./settings_notifications").then((m) => ({
    default: m.SettingsNotifications,
  })),
);
const SettingsOrganization = lazy(() =>
  import("./settings_organization").then((m) => ({
    default: m.SettingsOrganization,
  })),
);
const SettingsProfile = lazy(() =>
  import("./settings_profile").then((m) => ({ default: m.SettingsProfile })),
);
const SettingsSecrets = lazy(() =>
  import("./settings_secrets").then((m) => ({ default: m.SettingsSecrets })),
);
const SettingsSecurity = lazy(() =>
  import("./settings_security").then((m) => ({ default: m.SettingsSecurity })),
);

export const DASHBOARD_SETTINGS_ROUTE = {
  path: "settings",
  element: (
    <Suspense fallback={<Loader />}>
      <DashboardSettings />
    </Suspense>
  ),
  loader: DASHBOARD_SETTINGS_LOADER,
  handle: DASHBOARD_SETTINGS_LINK,
  children: [
    {
      path: "profile",
      element: (
        <Suspense fallback={<Loader />}>
          <SettingsProfile />
        </Suspense>
      ),
      handle: { name: "Profile", to: "/dashboard/settings/profile" },
    },
    {
      path: "notifications",
      element: (
        <Suspense fallback={<Loader />}>
          <SettingsNotifications />
        </Suspense>
      ),
      handle: {
        name: "Notifications",
        to: "/dashboard/settings/notifications",
      },
    },
    {
      path: "organization",
      element: (
        <Suspense fallback={<Loader />}>
          <SettingsOrganization />
        </Suspense>
      ),
      handle: { name: "Organization", to: "/dashboard/settings/organization" },
    },
    {
      path: "security",
      element: (
        <Suspense fallback={<Loader />}>
          <SettingsSecurity />
        </Suspense>
      ),
      handle: { name: "Security", to: "/dashboard/settings/security" },
    },
    {
      path: "secrets",
      element: (
        <Suspense fallback={<Loader />}>
          <SettingsSecrets />
        </Suspense>
      ),
      handle: { name: "Secrets", to: "/dashboard/settings/secrets" },
    },
    {
      path: "admin",
      element: (
        <Suspense fallback={<Loader />}>
          <SettingsAdmin />
        </Suspense>
      ),
      handle: { name: "Admin", to: "/dashboard/settings/admin" },
    },
    {
      index: true,
      element: <Navigate to="/dashboard/settings/profile" replace />,
    },
  ],
} satisfies RouteObject;
